export const STORYBLOK_VERSION = process.env.NEXT_PUBLIC_STORYBLOK_VERSION as "draft" | "published"
export const MAPS_API_KEY = process.env.GMAPS_API_KEY || ""
export const GEOCODE_API_KEY = process.env.GEOCODING_API_KEY || ""
export const AMPLITUDE_API_KEY = process.env.AMPLITUDE_API_KEY
